import FeeField from './FeeField';
import RegularFeeField from './RegularFeeField';
import StringField from './StringField';

export default {
  'veengu.fee': FeeField as any,
  'veengu.regularFee': RegularFeeField as any,
  StringField: StringField as any,
};
